export enum SignInErrors {
  INCORRECT_PASSWORD = 'Не корректный пароль.',
  INCORRECT_EMAIL_OR_PHONE = 'Не корректный номер или почта.',
}
